import styled from "styled-components";
import { Button as AntButton } from "antd";
import { SyncOutlined } from "@ant-design/icons";

export const Container = styled.div`
	display: flex;
	align-items: center;
	box-sizing: border-box;
	gap: 8px;

	padding: 16px;
	border-radius: 16px;
	border: 1px solid #FFD648;
	background: #FFF;
	box-shadow: 0px 0px 12px 0px rgba(0, 0, 0, 0.10);

	@media screen and (max-width: 350px) {
		padding: 8px;
		gap: 4px;
	}
`;

export const ActionButton = styled.div`
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	align-items: center;
	padding: 0 30px;
	cursor: pointer;

	:first-child {
		flex: 1;
		padding: 0 8px;
		flex-direction: row;
		gap: 4px;
	}

	@media screen and (max-width: 390px) {
		svg {
			width: 20px;
		}
	}
`;

export const BalanceText = styled.div`
	flex: 1;
	width: 100%;
	font-size: 12px;
	font-style: normal;
	font-weight: 400;
	line-height: 1.5;
	color: #fff;

	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	align-items: flex-start;

	text-align: left;
	padding: 0;
	position: relative;

	svg {
		color: #2A2A2A;
		margin-top: 5px;
	}

	p{
		color: #2A2A2A;
		font-size: 10px !important;
		font-style: normal;
		font-weight: 400;
		line-height: 20px; /* 200% */

		@media screen and (max-width: 390px) {
			font-size: 10px !important;
		}

		@media screen and (max-width: 340px) {
			padding-left: 0;
		}

		@media screen and (max-width: 320px) {
			font-size: 9px !important;
		}
	}
`;

export const ReloadIcon = styled(SyncOutlined)`
/* color: #e89e0c;
font-size: 18px; */
`;

export const Amount = styled.div`
	background: var(--color-gold-gradient, linear-gradient(133deg, #FFD648 -3.8%, #AA5E1B 100%));
	background-clip: text;
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;

	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 700;
	line-height: 26px; /* 162.5% */

	@media screen and (max-width: 380px) {
		font-size: 14px;
	}
	@media screen and (max-width: 320px) {
		font-size: 12px;
	}
`

export const Button = styled(AntButton)`
	font-size: 12px;
	border-radius: 100px !important;
	padding: 2px 8px;

	svg{
		width: 24px;
		height: 24px;
	}

	@media screen and (max-width: 390px){
		gap: 2px !important;
	}

	@media screen and (max-width: 350px){
		font-size: 11px;
	padding: 2px 6px 2px 4px;

		svg{
			width: 20px;
			height: 20px;
		}
	}
`